import DayOffRangeTimeFrom from '@/modules/Dayoffs/components/Form/RangeTimeForm'
import {
    DayOffNewPayload,
    DayOffRangeTime,
} from '@/modules/Dayoffs/types/payload'
import { ModalProps } from '@/types/shared'
import { UseFormSetValue } from 'react-hook-form'
import { Dialog } from 'vnetwork-ui'

export interface RangeTimeModalProps extends ModalProps {
    setValue: UseFormSetValue<DayOffNewPayload>
    watch: (value: string) => DayOffRangeTime[]
    append: (value: DayOffRangeTime) => void
}

const BomConfirmModal: React.FC<RangeTimeModalProps> = ({
    onClose,
    open,
    setValue,
    watch,
    append,
}) => {
    return (
        <Dialog onClose={onClose} open={open} title={'DateRangePicker'}>
            <DayOffRangeTimeFrom
                setValue={setValue}
                watch={watch}
                append={append}
                onClose={onClose}
            />
        </Dialog>
    )
}

export default BomConfirmModal
